
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricelistValueSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VIPPriceListValue"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"VIPExternalId"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
